<!-- <div class="article-item align-h align-start cursor-pointer" (click)="viewDetails()"> -->
   <div
  class="article-item align-h align-start cursor-pointer"
  role="button"
  tabindex="0"
  (click)="viewDetails()"
  (keydown.enter)="viewDetails()"
  (keydown.space)="viewDetails(); $event.preventDefault()">
   <div class="article-thumbnail">
      <img [src]="article.thumbnailImage ? article.thumbnailImage : '/assets/images/logo_ITI-small.svg'" alt=""  />
      <img  *ngIf="isYoutubeVedio" class="play-btn" src="/assets/images/RedPlay.svg" alt=""
      aria-hidden="true"> 
   </div>
    <div class="stretch article-thumbnail-content">
       <p class="tab-item-year-month">{{article.month}}, {{article.year}}</p>
       <h3 class="tab-item-title">{{article.title}}</h3>
       <p *ngIf="!hideDecription" class="tab-item-short-description">{{article.shortDesc}}</p>
    </div>
 </div>